const featureFlags = {
    AD_CREATE_ENABLED: true,
    ASSETS_UI: false,
    BILLING_CANCEL_PLAN_ENABLED: true,
    CHURNKEY_APP_ID: '5dd9uhvls',
    CONCEPTS_ENABLED: false,
    DISCOVER_FOR_YOU_ENABLED: true,
    DIRECTORIES: true,
    FACEBOOK_API_VERSION: 'v22.0',
    FACEBOOK_APP_ID: '819853776430547',
    FACEBOOK_APP_LOGIN_CONFIG_ID: '964923651718214',
    FACEBOOK_ASSET_PRODUCT_IMAGE_INGESTION_ENABLED: false,
    FACEBOOK_CONNECT_USE_ROLES_ENABLED: false,
    FIREBASE_CLIENT_EMAIL: 'firebase-adminsdk-qmsnr@magicbrief-56897.iam.gserviceaccount.com',
    FIREBASE_PROJECT_ID: 'magicbrief-56897',
    FOR_YOU_PAGE: false,
    GTM_CONTAINER_ID: 'GTM-W6M2QNT',
    HOCUSPOCUS_PATH: '/ws2',
    INSIGHTS_BREAKDOWNS_ADDITIONAL_ENABLED: false,
    INSIGHTS_COMPARE_GROUPS_ENABLED: true,
    INSIGHTS_COPILOT_ENABLED: true,
    INSIGHTS_DASHBOARD_ENABLED: true,
    INSIGHTS_DASHBOARD_VERSION: 7,
    INSIGHTS_DISPLAY_METRICS_V2_ENABLED: true,
    INSIGHTS_GUEST_USERS_ENABLED: true,
    INSIGHTS_REPORT_SHARING_ENABLED: true,
    INSIGHTS_TIK_TOK_ENABLED: true,
    INSIGHTS_TIME_PERIOD_FILTER_V2_ENABLED: true,
    JOB_AD_SEARCH_INGESTOR_ENABLED: true,
    JOB_CUSTOM_SCHEDULED_JOB_PROCESSOR_ENABLED: true,
    JOB_RELAY_NOTIFICATIONS_RELAY_SCHEDULE_SECONDS: 30,
    MAGICAI_VERSION: 'no version provided',
    MAIL_SERVICE_AUTH_USER: 'api',
    MAIL_SERVICE_FROM: 'donotreply@magicbrief.com',
    MAIL_SERVICE_HOST: 'send.smtp.mailtrap.io',
    MAIL_SERVICE_PORT: 587,
    MAILTRAP_SENDER_EMAIL: 'noreply@magicbrief.com',
    MAILTRAP_SENDER_NAME: 'MagicBrief',
    REGO_SLACK_REPORTING: true,
    REGO_SLACK_URL: 'https://hooks.slack.com/services/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',
    MAILTRAP_TEMPLATE_UUID_BOARD_INVITE: '36e3c459-45e4-45c2-94fa-3f04d1fba3a5',
    MAILTRAP_TEMPLATE_UUID_BRIEF_INVITE: 'f6160a4f-4ba9-4427-9b66-5580a3c86ff7',
    MAILTRAP_TEMPLATE_UUID_BRIEF_ASSIGNED_UPDATE: 'fa25fd39-4f91-449e-b129-eaf63566cc83',
    MAILTRAP_TEMPLATE_UUID_BRIEF_DUE_DATE_UPDATE: '2844a4a6-9374-4032-bccb-c29d027e23e6',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STAGE_UPDATE: 'e4204a97-f97a-43de-95ee-30fd13e78d0c',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STATUS_UPDATE: 'db4f345c-d77f-4d8c-98ed-0be5d9cdac01',
    MAILTRAP_TEMPLATE_UUID_COMMENT_MENTION: '5a69e27a-bf0e-4a9f-8ea0-e77f3f648f94',
    MAILTRAP_TEMPLATE_UUID_INSIGHTS_AD_INVITE: '47bcff6b-e53b-428e-8305-6ce8d8612aac',
    MAILTRAP_TEMPLATE_UUID_INSIGHTS_REPORT_INVITE: '98a2e7ae-bd72-4c46-8daf-b8e7a2a772ee',
    MAILTRAP_TEMPLATE_UUID_ORGANISATION_INVITE: '9a9891b0-af26-494f-beb6-a8dcca4004ba',
    MB_API_URL: 'https://mb-production-api.magicbrief.com',
    MB_CLIENT_URL: 'https://app.magicbrief.com',
    MB_SHARE_URL: 'https://share.magicbrief.com',
    NOTIFICATIONS_EMAIL: true,
    NOTIFICATIONS_IN_APP: true,
    PRESENCES: false,
    PYLON_APP_ID: '5bc8060c-0680-4adf-8de4-4ae951b5506a',
    USE_PROXY: true,
    SHOW_MAGIC_AI_SCENES: false,
    SCREENSHOT_FUNCTION_URL: 'https://mb-production-functions.azurewebsites.net/api/screenshot',
    SEGMENT_KEY_V3: 'ZSP7vYR0Ztrk4CnZEegy7BjhTHDXD8ku',
    SEARCH_ENGINE: 'typesense',
    SEARCH_VERSION: 'v2',
    SENTRY_DSN_API: 'https://a2be9b8e82c2bc22bca24e08f7b60e20@o4504063794348032.ingest.us.sentry.io/4504063806406657',
    SENTRY_DSN_JOBS: 'https://0b38a0b663bab03f56ff297d2567f3b2@o4504063794348032.ingest.us.sentry.io/4506193515184128',
    SERVER_PORT: 8000,
    SHORT_URL: 'https://app.magicbrief.com',
    SHOW_GPT_BOARDS: true,
    SLACK_CLIENT_ID: '3631056502098.6781935270240',
    SLACK_DEBUG_URL: 'https://hooks.slack.com/services/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',
    SLACK_REDIRECT_URI: 'https://app.magicbrief.com/?redirect=/slack/oauth',
    SLACK_REDIRECT_URI_PATH: '/?redirect=/slack/oauth',
    SLACK_WEBHOOK_AD_ACCOUNT_EVENTS_URL: 'https://hooks.slack.com/services/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',
    SLACK_WEBHOOK_EVENTS_BRANDS: 'https://hooks.slack.com/services/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',
    SLACK_WEBHOOK_URL: 'https://hooks.slack.com/services/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',
    SOCKET_IO_PATH: '/ws1',
    SYNC_TO_TYPESENSE: true,
    TIK_TOK_API_VERSION: 'v1.3',
    TIK_TOK_APP_ID: '7382050893274808337',
    YOUTUBE_INTEGRATION_ENABLED: false,
    YOUTUBE_CLIENT_ID: '722421198048-seosob5tqo8q4b65tumd7ra45lghapmi.apps.googleusercontent.com',
    YOUTUBE_REDIRECT_URI: 'https://app.magicbrief.com/googleads/oauth',
    TIK_TOK_OAUTH_URL: 'https://business-api.tiktok.com/portal/auth?app_id=7382050893274808337&redirect_uri=https%3A%2F%2Fapp.magicbrief.com%2Ftiktok%2Foauth',
    USER_HYDRATE_HAS_QUALIFIED_EMAIL: true,
    WIZARD_JOB_CALLBACK_URL: 'https://mb-production-jobs.magicbrief.com/api/v1/wizard_jobs/handle_asset',
    WIZARD_JOB_WEBHOOK_URL: 'https://mb-production-wizard.magicbrief.com/api/v1/process_asset',
};
export default featureFlags;
//# sourceMappingURL=production.js.map